import { BACKEND_URL, get } from '../../util/api'

export const uploadCSV = (data) => {
    return fetch(BACKEND_URL + '/api/foil-supply/upload-foil-csv', {
        method: 'post',
        body: data,
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    })
}

export const loadFoilList = () => get('/api/foil-supply/get-foil-list')



// WEBPACK FOOTER //
// ./src/modules/foil/api.js